import axios from 'axios';

import { ApiBase, generalErrorLogging } from '.';
import { Categories, Event } from '../data';

export interface getEventsParams {
    category?: keyof typeof Categories;
    to?: string;
    from?: string;
    limit?: number;
}

export const getEvents = async (params?: getEventsParams): Promise<Array<Event>> => {
    return (
        axios
            // Note: Backend defaults to limit=100 and restricts limit <= 1000.
            // Currently pagination/filtering/sorting is done on the FE.
            .get(`${ApiBase}/events`, {
                params: {
                    limit: 1000,
                    ...params,
                },
            })
            .then((resp) => {
                return resp.data?.items;
            })
            .catch((e) => generalErrorLogging(e))
    );
};
